import { render, staticRenderFns } from "./SpecialOneTitle.vue?vue&type=template&id=04d01404&scoped=true"
import script from "./SpecialOneTitle.vue?vue&type=script&lang=js"
export * from "./SpecialOneTitle.vue?vue&type=script&lang=js"
import style0 from "./SpecialOneTitle.vue?vue&type=style&index=0&id=04d01404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d01404",
  null
  
)

export default component.exports